import { Typography } from '@mui/material'
import { Breadcrumbs } from '@mui/material'
import { Link } from '@mui/material'
import { Grid } from '@mui/material'
import React from 'react'
import Education from './Education'
import { useLocation } from 'react-router-dom'
import Header from '../Header'


function UserEducationPage() {

    const location = useLocation();
    const { handleCB, education } = location.state;
    return (
        <>
            <Header />
            <div className='full-container'>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit"
                        onClick={() => { }}
                    >
                        Home
                    </Link>
                    <Typography color="text.primary">{`Education`}</Typography>
                </Breadcrumbs>
                <div style={{ marginTop: '20px' }}>
                    <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                        {education && education.length > 0 && education.map((edu, index) => {
                            return <Education key={index} education={edu} />
                        })
                        }
                        {!education && <div>
                            <Typography sx={{ fontSize: '18px', fontWeight: 600 }} component={'div'}>
                                Great!
                                <Typography component={'span'}> you have completed all your education. </Typography>
                            </Typography>
                        </div>}
                    </Grid>
                </div>
            </div>
        </>
    )
}

export default UserEducationPage;